import { createStore } from 'satcheljs';
export default createStore('blockedSendersOption', {
    blockedSenders: null,
})();
//# sourceMappingURL=store.js.map